import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import qs from 'qs';
import { isNotNil } from '@flowio/is';
/**
 * Submits an HTML form element with the provided parameters as hidden
 * HTML input elements.
 */

export default function postRedirect(location, parameters) {
  var form = document.createElement('form');
  form.setAttribute('method', 'POST');
  form.setAttribute('action', location);
  var queryString = qs.stringify(parameters, {
    encode: false
  });
  queryString.split('&').forEach(function (parameter) {
    var _parameter$split = parameter.split('='),
        _parameter$split2 = _slicedToArray(_parameter$split, 2),
        name = _parameter$split2[0],
        value = _parameter$split2[1];

    if (isNotNil(name) && isNotNil(value)) {
      var input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', name);
      input.setAttribute('value', value);
      form.appendChild(input);
    }
  });
  document.body.appendChild(form);
  form.submit();
}
//# sourceMappingURL=postRedirect.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/~/@flowio/browser-helpers/lib/esm/postRedirect.js
// module id = 682
// module chunks = 0 1